import { Input } from 'Constants/styles';

import styled from '@emotion/styled';

export const EditBtn = styled.button`
  background-color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  color: var(--lp-colors-medium-blue-600);
  font-size: 15px;
  font-weight: 300;
  padding: 0;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    color: var(--lp-colors-medium-blue-800);
  }
  &:focus {
    outline: none;
  }
`;

export const FilterBtn = styled.button`
  padding: 5px 10px;
  border: none;
  background-color: white;
  cursor: pointer;
  margin-top: 40px;
  margin-bottom: 10px;
  margin-left: 20px;
  font-size: 15px;
  font-weight: 300;
  text-decoration: none;
  color: var(--lp-colors-medium-blue-600);

  svg {
    vertical-align: top;
  }
`;

export const SpinnerWrapper = styled.div`
  height: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EditFormRow = styled.div`
  display: flex;
  input {
    max-height: 40px;
  }
`;

export const FormControl = styled.select`
  display: block;
  width: 100%;
  height: 40px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
`;

export const ActivateBtn = styled.button`
  width: 80px;
  height: 24px;
  background-color: var(--lp-colors-medium-blue-600);
  border: 1px solid var(--lp-colors-medium-blue-600);
  border-radius: 4px;
  cursor: pointer;
  color: #fff;
  padding: 4px 10px 4px 10px;
  margin-left: 20px;
  font-size: 13px;
  &:focus {
    outline: none;
  }
`;

export const TextInput = styled(Input)`
  padding-left: 10px;
`;

export const FormField = styled.div`
  position: relative;
`;

export const FormCurrencyField = styled.div`
  position: relative;
  &:before {
    content: '$';
    left: 1px;
    top: 1px;
    border: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    position: absolute;
    line-height: 38px;
    background: #f8f9fb;
    width: 35px;
    text-align: center;
  }
`;

export const Button = styled.button`
  position: relative;
`;

export const PaginationRow = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
`;
